/**
 * GB and CH complete ID verification and photo questions post-purchase (My Account pending actions).
 */

const POST_CHECKOUT_VERIFICATION_COUNTRIES = ["gb", "ch"] as const;

export const isPostCheckoutVerificationCountry = (country?: string | null): boolean =>
  (POST_CHECKOUT_VERIFICATION_COUNTRIES as readonly string[]).includes((country ?? "").toLowerCase());
